const routes = [
    {
        path: "/student/courses",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentcourse_index"
        },
        component_full_path: 'studentCourses/pages/Index'
    },
    {
        path: "/student/courses/section/updates",
        component: () => import("../pages/SectionUpdate"),
        meta: {
            isAuthenticated: true,
            permission: "studentcourse_sectionupdate"
        }
    },
    {
        path: "/show/student/courses",
        component: () => import("../pages/ShowStudentCourse.vue"),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_studentcourseswithattendance'
        },
        component_full_path: 'studentCourses/pages/ShowStudentCourse'
    },
    {
        path: "/student/courses/student-affairs-entry",
        component: () => import("../pages/StudentAffairsEntry"),
        meta: {
            isAuthenticated: true,
            permission: 'studentcourse_studentaffairsentry'
        }
    },
    {
        path: "/student/courses/student-affairs-grade-import",
        component: () => import("../pages/GradeEntryImport"),
        meta: {
            isAuthenticated: true,
            permission: 'studentcourse_importlettergradeforstudentaffairs'
        }
    }

];

export default routes;
